import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

interface RecipeSearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

const RecipeSearchBar = ({ value, onChange }: RecipeSearchBarProps) => (
  <div className="relative">
    <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground" />
    <Input
      placeholder="Buscar receta, ingrediente..."
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="pl-8 h-9 text-xs rounded-lg"
    />
  </div>
);

export default RecipeSearchBar;
